import { RewardsConfig } from './../rewards/rewards.models';
import { PromotionsConfig } from './../promotions/promotions.models';
import { BannerConfig } from '../banner-hero/banner.models';
import { BottomNavIconConfig } from '../bottom-nav/bottom-nav.models';
import { GameDetails } from '../game-details/games-details.model';
import { GamesNumberConfig } from '../games-results/games-results.models';
import { HeaderConfig } from '../header/header.models';
import { LoginConfig } from '../login/login.models';
import { Menu } from '../menu/menu.models';
import { SupportConfig } from '../support/support.models';
import { VipPageConfig } from '../vip/vip.models';
import { FooterConfig, LinksConfig, LogosConfig } from './../footer/footer.models';
import { Jurisdication } from './visitor/visitor.model';
import { AboutConfig } from '../about/about.models';
import { LoginErrorModalComponentConfig } from '../login/login-error-modal/login-error-modal.models';
import { HomeIconsConfig } from '../icons-section/icons-section.models';

export interface RestrictionCriteriasConfig {
  excludedJurisdictions?: Jurisdication[];
  includedOnlyLanguages?: string[];
  excludedOnlyLanguages?: string[];
}

export type AllowedAreas = LinksConfig & LogosConfig;

export enum ImageTypes {
  Portrait = '/images/portrait/',
  Landscape = '/images/games/',
  Mobile = '/images/mobile/icons/new-icons/'
};

export enum RestrictedPages {
  Account = 'account',
  Responsible = 'responsible-gambling',
  Messages = 'messages',
  Marketing = 'marketingprefs',
  Brands = 'brands',
  KYC = 'kyc'
}

export enum PrefixLangs {
  DefaultJurisdiction = 'ukgc',
  Header = '.header',
  Footer = '.footer',
  BannerHero = '.banner-hero',
  BottomNav = '.bottom-nav',
  GameDetails = '.games-details',
  GameDesktopTile = '.game-desktop-tile',
  GameFilterCategories = '.game-filter-categories',
  GamesResults = ".games-results",
  Login = ".login",
  Menu = ".menu",
  PlayDemoBottom = ".play-demo-bottom",
  Search = ".search",
  Support = ".support",
  Vip = ".vip",
  Banner = ".banner",
  Promotions = ".promotions",
  GameTypeGames = ".game-type-games",
  About = ".about",
  Rewards = ".rewards",
  Slider = ".slider",
  LoginErrorModal = ".login-error-modal",
  IconsHome = ".icons-home",
}

export enum Languages {
  EN = 'English',
  DE = 'Deutsch',
  ES = 'Español',
  FR = 'Français',
  FI = 'Suomi',
  NO = 'Norsk'
}

export enum sessionStorageItems {
  UserDetails = 'userDetails'
}

export type ComponentConfig =
BannerConfig |
BottomNavIconConfig[] |
FooterConfig |
GameDetails |
GamesNumberConfig |
HeaderConfig |
LoginConfig |
Menu |
SupportConfig |
VipPageConfig |
PromotionsConfig |
AboutConfig |
RewardsConfig |
LoginErrorModalComponentConfig |
HomeIconsConfig;

export interface ImgRGB {
  r: number;
  g: number;
  b: number;
}
